let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e7a2r")).then(() => parcelRequire('dqid6'));